import { FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { OrganizationInfo } from 'src/api/types';

import { FieldSkeleton } from '../FieldSkeleton/FieldSkeleton';

import {
  OrganizationAutocomplete,
  OrganizationAutocompleteProps,
} from './OrganizationAutocomplete';

export interface FormDepartmentAutocompleteProps
  extends Omit<OrganizationAutocompleteProps, 'value' | 'onChange'> {
  name: string;
  onChange?: (value: Option<OrganizationInfo> | null) => void;
  loading?: boolean;
}

export const FormOrganizationAutocomplete: FC<
  FormDepartmentAutocompleteProps
> = ({ name, required, onChange, onInputChange, loading, ...rest }) => {
  const validate = useCallback(
    (value: Option<OrganizationInfo> | null) => {
      if (required && !value) return 'Заполните поле';

      return '';
    },
    [required],
  );

  const { input, meta } = useField(name, { type: 'string', validate });

  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (value: Option<OrganizationInfo> | null) => {
      input.onChange(value);
      onChange?.(value);
    },
    [input, onChange],
  );

  const handleInputChange = useCallback(
    (value: string) => {
      input.onChange(null);
      onInputChange?.(value);
    },
    [input, onInputChange],
  );

  return loading ? (
    <FieldSkeleton />
  ) : (
    <OrganizationAutocomplete
      value={input.value}
      {...rest}
      required={required}
      error={!!error}
      helperText={error}
      onChange={handleChange}
      onInputChange={handleInputChange}
    />
  );
};
